import React, { useState, useEffect } from 'react';
import Main_Spring from '../component/Spring/Main_Spring';
import Info_Spring from '../component/Spring/Info_Spring';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import axios from 'axios';
import Save_Date from '../component/Save_Date';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import AccountList from '../component/Account/AccountList';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import Interview_Spring from '../component/Spring/Interview_Spring';
import winterMusicFile from "../asset/music/winter.mp3";
import CallInfo from '../component/CallInfo';
import ParentInfo from '../component/Info/ParentInfo';

const KimMinGyeong = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김희종❤️김민경 결혼합니다.";
    const openDesc = "2025.05.10. 토요일 오후 12:20\n그랜드 머큐어 앰배서더 창원 5층 가든하우스";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/79/thumb.jpg";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen:''
    });

    const conceptStyle = {
        // spring 핑크B
        concept: "SPRING",
        titleColor: "#ff8faf",
        pointColor: "#ff8faf",
        btnBgColor: "#ffcfe1",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }


    const groomAccountList = [
        {
            role: "신랑",
            name: "김희종",
            bank: "농협",
            accountNumber : "846-12-046018",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej79De7j2"
        },
        {
            role: "신랑 아버지",
            name: "김준호",
            bank: "농협",
            accountNumber : "846-12-030347",
            isKakao : false
        },
        {
            role: "신랑 어머니",
            name: "윤소영",
            bank: "농협",
            accountNumber : "302-0458-1507-71",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "김민경",
            bank: "농협",
            accountNumber : "302-0422-9527-41",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8thjwai"
        },
        // {
        //     role: "신부 부",
        //     name: "어철",
        //     bank: "농협은행",
        //     accountNumber : "207054-52-409958",
        //     isKakao : false
        // },
        {
            role: "신부 어머니",
            name: "홍희숙",
            bank: "농협",
            accountNumber : "805-02-181755",
            isKakao : false
        }
    ]

    

    const msg1 = "꽃향기 가득한 봄날,\n인생의 반려자를 만나\n새로운 인생을 시작하려 합니다.";
    const msg2 = "봄처럼 따듯한 마음으로\n저희의 새로운 시작을 축복해 주시면 감사하겠습니다.";

    const lng = 128.655293143724;
    const lat =  35.2392858782629;

    const placeTelNum = "055-600-0800~2";

    const forParking = "호텔 2층, 3층, 지상 5층 (3시간 무료)\n창원컨벤션센터 이용 시 \n프론트데스크나 연회예약실, 식사장소에서 주차권 수령 \n(3시간 무료)\n시티세븐 주차장 무료";
    const forBus = "하차정류장 : 시티7 & 창원컨벤션센터 \n\n17, 58, 103, 105, 109, 113, 155, 221, 710, 720, \n3001, 3006, 5000, 6000"

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const parents = [
        {groom : "김준호 · 윤소영의 아들"},
        {bride : "故김종수 · 홍희숙의 딸"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "김준호", isDeceased: false },
            mom: { name: "윤소영", isDeceased: false },
            role: "아들",
        },
        bride: {
            dad: { name: "김종수", isDeceased: true },
            mom: { name: "홍희숙", isDeceased: false },
            role: "딸",
        }
    };
    
    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김희종",
            call: "010-5696-6955"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "방신혁",
        //     call: "010-5095-0666"
        // },
        // {
        //     role: "신랑 모",
        //     name: "최은희",
        //     call: "010-3327-7327"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "김민경",
            call: "010-4048-3192"
        }
        // ,{
        //     role: "신부 부",
        //     name: "안세정",
        //     call: "010-3916-6937"
        // }
        // ,{
        //     role: "신부 모",
        //     name: "서경미",
        //     call: "010-2266-6937"
        // }
    ]


    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "너무 예뻤어",
            brideAnswer: "눈에 하트 뿅"
        },
        {
            question : "우리 커플을 소개한다면?",
            groomAnswer: "미녀와 야수",
            brideAnswer: "원빈 이나영"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "평생 잘할게",
            brideAnswer: "유부초밥 짱"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "잘 살게요❤️"
        }
    ]

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();
    }, []);

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);


    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    if (!weddingData || !conceptStyle) return <Loading color={weddingData.pointColor}/>;
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ff8faf"} loading={loading} />
            ) : (
            <>
            <Music concept={conceptStyle.concept} musicTitle={winterMusicFile}/>
            <Main_Spring groomNameEn={toUpperCaseString(weddingData.brideNameEn)} brideNameEn={toUpperCaseString(weddingData.groomNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
            <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
            <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
            <Letter title={"우리 결혼합니다."} msg1={msg1} msg2={msg2}conceptStyle={conceptStyle}/>
            <MotionWrapper initialY={70}>
                <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
            </MotionWrapper>
            <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
            <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                <MotionWrapper initialY={50}>
                <GalleryList color={conceptStyle.pointColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} photoHeight={"235px"} gap={"3px"}/>
                    <MotionWrapper initialY={70}>
                    <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                        <MotionWrapper initialY={70}>
                            <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} conceptStyle={conceptStyle} btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.pointColor}/>
                            <MotionWrapper initialY={50}>
                                {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                                <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                <Location_Desc forParking={forParking} forBus={forBus} conceptStyle={conceptStyle}/>
                                <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                <Footer />
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </MotionWrapper>
            </>
            )}
        </div>
    );
};

export default KimMinGyeong;
